<template>
  <div>
    <dropdown-tooltip :availableItems="availableCurrencies"
                      :changeItemHandler="changeItemHandler"
                      :clickItemHandler="fetchUserCurrencyPreferences"
                      :preselectedItem="preselectedItem"
                      :dropUpDirection="dropUpDirection">
      <div class="level">
        <div class="level-item">
          <svg-icon name="currency-grey" width="16" height="16"></svg-icon>
          <a :class="$mq.phone ? 'paragraph-s': 'paragraph'" class="dark-gray-link">{{ preselectedItem }}</a>
        </div>
      </div>
    </dropdown-tooltip>
  </div>
</template>

<script>

import '../distribution/icons/currency-grey';

import DropdownTooltip from './DropdownTooltip';

export default {
  props: {
    changeItemHandler: Function,
    dropUpDirection: {type: Boolean, default: false},
    preselectedItem: String
  },
  computed: {
    availableCurrencies() {
      return this.$store.getters.userPreferencesState.meta.choices.currencies;
    }
  },
  methods: {
    fetchUserCurrencyPreferences() {
      if (!this.$store.getters.userPreferencesState.currency) {
        this.$store.dispatch('getUserPreferencesAction');
      }
    }
  },
  components: {DropdownTooltip}
};
</script>
